module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-bio"
  }, [_c('div', {
    staticClass: "section-bio-left"
  }, [_c('div', {
    staticClass: "text-bio-header"
  }, [_vm._v(_vm._s(_vm.bio.head))])]), _vm._v(" "), _c('div', {
    staticClass: "section-bio-right"
  }, [_c('p', [_vm._v("   " + _vm._s(_vm.bio.body1))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("   " + _vm._s(_vm.bio.body2))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc777674!./~/vue-loader/lib/selector.js?type=template&index=0!./src/bio/components/index.vue
// module id = 597
// module chunks = 2